import { Box, Button } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import { DrawerContainer } from '../../../components/Drawer/DrawerContainer';
import { DrawerHeaderWithLeftIcon } from '../../../components/Drawer/DrawerHeader';
import { LogAuditoriaSection } from './LogAuditoriaSection';
import { SiniestroItem } from '../types/siniestros.types';

interface Props {
    open: boolean;
    onClose: () => void;
    siniestro: SiniestroItem | null;
}

export function SiniestroHistoryDrawer({ open, onClose, siniestro }: Props) {
    const siniestroId = siniestro?.id ? Number(siniestro.id) : undefined;
    const numeroSiniestro = siniestro?.nroRoam || siniestro?.nroSiniestro || siniestro?.id || '';
    const empleadoNombre = siniestro?.empleado?.nombre;

    return (
        <DrawerContainer open={open} setOpen={onClose} onClose={onClose} customWidth={520}>
            <Box display="flex" flexDirection="column" height="100%">
                <DrawerHeaderWithLeftIcon
                    onIconClick={onClose}
                    text="Log de auditoría"
                    subtitle={`#${numeroSiniestro}${empleadoNombre ? ` · ${empleadoNombre}` : ''}`}
                    LeftIcon={<HistoryIcon sx={{ fontSize: 20, color: '#64748B' }} />}
                />
                <Box flex={1} minHeight={0} mt={2} sx={{ overflowY: 'auto' }}>
                    <LogAuditoriaSection idSiniestroRoam={open ? siniestroId : undefined} />
                </Box>
                <Box sx={{ flexShrink: 0, mx: -2.5, mt: 2, px: 2.5, py: 2, backgroundColor: '#FFFFFF', borderTop: '1px solid #E2E8F0' }}>
                    <Button
                        fullWidth
                        variant="contained"
                        onClick={onClose}
                        sx={{
                            backgroundColor: '#1E293B',
                            '&:hover': { backgroundColor: '#0F172A' },
                            textTransform: 'none',
                            fontWeight: 600
                        }}
                    >
                        Cerrar
                    </Button>
                </Box>
            </Box>
        </DrawerContainer>
    );
}
